import { PropsWithChildren } from "react";
import { useAuthCtx } from "./useAuthCtx.ts";
import { Navigate } from "react-router";
import { returnToUrlHandler } from "./returnToUrlHandler.ts";
import { getRolesFromAuth0User } from "./getRolesFromAuth0User.ts";
import { NotHavePermissionToSeePageScreenPath } from "./NotHavePermissionToSeePageScreen.tsx";
import { FullPageLoading } from "../UI/FullPageLoading.tsx";

export function ProtectedRoute({
  redirectIfNotAuthenticatedUrl,
  children,
  path,
  requiredRoles,
}: PropsWithChildren<{
  redirectIfNotAuthenticatedUrl: string;
  path: string;
  requiredRoles?: string[];
}>) {
  const { isAuthenticated, isLoading, user } = useAuthCtx();
  if (isLoading) return <FullPageLoading />;
  if (!isAuthenticated)
    return (
      <Navigate
        to={returnToUrlHandler.decoratePath(
          redirectIfNotAuthenticatedUrl,
          path,
        )}
      />
    );

  if (
    requiredRoles &&
    requiredRoles.every(
      (reqRole) => !getRolesFromAuth0User(user!).includes(reqRole),
    )
  )
    return <Navigate to={NotHavePermissionToSeePageScreenPath} />;
  return children;
}
